import { render, staticRenderFns } from "./VOutbox.vue?vue&type=template&id=5a3dc6c8&"
import script from "./VOutbox.vue?vue&type=script&lang=js&"
export * from "./VOutbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports